/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRipple = createReactComponent("outline", "ripple", "IconRipple", [["path", { "d": "M3 7c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-0" }], ["path", { "d": "M3 17c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-1" }], ["path", { "d": "M3 12c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-2" }]]);

export { IconRipple as default };
//# sourceMappingURL=IconRipple.mjs.map
